<template>
  <div class="" @click="closeSelectCollapse">
    <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button @click="back">返回管理页面</el-button>
      </div>
    </ZnBreadcrumb>
    <div class="main-content">
      <div class="topLine">
        <button class="cursorPointer" @click="back">取消</button>
        <button class="cursorPointer" @click="confirmAdd1" v-if="type == 1">
          保存
        </button>
        <button class="cursorPointer" @click="confirmEdit1" v-else>
          确认编辑
        </button>
      </div>
      <!--表单-->
      <div class="innerBox">
        <!--左侧-->
        <div class="left">
          <div class="line">
            <div class="leftText">CAS号<span class="requiedText">*</span></div>
            <div class="rightBox">
              <!-- :disabled="type == 2" -->
              <input
                  type="text"
                  placeholder="请输入CAS号"
                  v-model="form.casNo"
                  maxlength="20"
              />
              <span
                  slot="reference"
                  class="searchText"
                  id="slectTable"
                  @click="quickSearchClick"
                  v-if="type == 1"
              >快速查询</span
              >
              <div class="infoTable">
                <el-collapse-transition>
                  <div v-show="showTable">
                    <el-table
                        :data="reagentList"
                        style="width: 100%"
                        :header-cell-style="{
                        background: '#F8FAFC',
                        color: 'rgba(0, 0, 0, 0.85)',
                        fontWeight: 600,
                      }"
                    >
                      <el-table-column prop="reagentName" label="商品名称">
                      </el-table-column>
                      <el-table-column prop="casNo" label="CAS号">
                      </el-table-column>
                      <!--                      <el-table-column prop="goodsNo" label="商品编码" width="97"></el-table-column>-->
                      <!-- <el-table-column label="结构式" width="78">
                        <template slot-scope="scope">
                          <img
                            :src="scope.row.structionImg"
                            alt=""
                            class="tableImg"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="产品图片" width="93">
                        <template slot-scope="scope">
                          <img
                            :src="scope.row.coverImg"
                            alt=""
                            class="tableImg"
                          />
                        </template>
                      </el-table-column> -->

                      <el-table-column prop="specNames" label="规格" width="70">
                      </el-table-column>
                      <el-table-column prop="reason" label="品牌" width="100" />
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <span @click="fillIn(scope.row)" class="searchText"
                          >填入</span
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                    <Pagination
                        :dataTotal="dataTotal"
                        :totalpage="totalpage"
                        :pagesize="searchData.pageSize"
                        @changePage="changePage"
                    ></Pagination>
                  </div>
                </el-collapse-transition>
              </div>
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              试剂名称
            </div>
            <!--
                :disabled="type == 2" -->
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入试剂名称"
                  v-model="form.reagentName"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText" >总剂量</div>
            <div class="rightBox">
              <!-- :disabled="type == 2" -->
              <input
                  type="text"
                  placeholder="请输入重量"
                  v-model="form.reagentWeight"
                  maxlength="20"
                  oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')
                if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  @blur="reagentWeightBlur"
              />
            </div>
            <div class="leftText" style="margin-left: 20px;margin-right: -10px">剩余剂量</div>
            <!--            <span style="margin-left: 20px;margin-right: 10px">剩余剂量 </span>-->
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入重量"
                  v-model="form.reagentRemainWeight"
                  maxlength="20"
                  oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')
                if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  @blur="reagentWeightBlur"
              />
            </div>
            <!--
              v-if="type == 1" -->
            <el-dropdown
                trigger="click"
                @command="handleCommand"
                style="width: 50px"
            >
              <span class="el-dropdown-link">
                {{ currentCommand
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ val: 1, text: 'mL' }"
                >mL</el-dropdown-item
                >
                <el-dropdown-item :command="{ val: 4, text: 'L' }"
                >L</el-dropdown-item
                >

                <el-dropdown-item :command="{ val: 3, text: 'mg' }"
                >mg</el-dropdown-item
                >
                <el-dropdown-item :command="{ val: 2, text: 'g' }"
                >g</el-dropdown-item
                >
                <el-dropdown-item :command="{ val: 5, text: 'kg' }"
                >kg</el-dropdown-item
                >
                <el-dropdown-item :command="{ val: 6, text: 'KU' }"
                >KU</el-dropdown-item
                >
                <el-dropdown-item :command="{ val: 7, text: 'U' }"
                >U</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <span
              style="
                color: #333;
                margin-left: 16px;
                border-bottom: 1px solid #cccccc;
                width: 38px;
                height: 50px;
                line-height: 50px;
                text-align: center;
              "
              v-else
              >{{ currentCommand }}</span> -->
          </div>
          <div class="line">
            <div class="leftText">
              纯度
            </div>
            <!--
                :disabled="type == 2" -->
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入纯度"
                  v-model="form.pure"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              存储位置<i class="el-icon-info"></i>
              <!--              <span class="requiedText2">*</span>-->
              <!-- <span class="requiedText">*</span> -->
            </div>
            <div class="rightBox">
              <input
                  type="text"
                  readonly
                  v-model="searchCab"
                  placeholder="请选择柜机"
                  maxlength="20"
              />
              <span slot="reference" class="searchText" @click="getCanUseList"
              >选择柜机</span
              >
            </div>
          </div>

          <!--      ***************************************************************    -->
          <el-dialog
              title="选择柜机"
              :visible.sync="dialog1Select"
              width="900px"
          >
            <div v-if="list && list.length>0" class="line">
              <div class="rightBox">
                <input
                    type="text"
                    v-model="searchCab2"
                    placeholder="请输入柜机名称"
                    maxlength="20"
                    @input="getCanUseList2"
                />
                <span
                    slot="reference"
                    class="searchText"
                    @click="getCanUseList2"
                >快速搜索</span
                >
              </div>
            </div>
            <div v-else>
              <div class="line">
                <div class="rightBox">
                  <input
                      type="text"
                      placeholder="您还没有柜机哦，现在去新建一个吧"
                      maxlength="20"
                  />
                </div>
              </div>
              <div style="text-align:center;margin-top: 20px">
                <el-link :underline="false" type="primary" @click="newCabinet">去新建 >></el-link>
              </div>
            </div>
            <div class="list">
              <div class="listItem" v-for="(item, index) in list" :key="index">
                <label @click="onRadioClick(item)">
                  <el-radio
                      v-model="form.cabId"
                      :label="item.id"
                      border
                      @change="onRadioChange(item)"
                  >
                    <div class="leftInner">
                      <div class="name">{{ item.cabName }}</div>
                      <span class="type1" v-if="item.cabType == 1">智能柜</span>
                      <span class="type2" v-else>门禁柜</span>
                    </div>
                    <div class="rightInner">
                      <div v-if="item.cabType == 1">
                        <span class="last">剩余可存量：</span>
                        <span>{{ item.sumGrid }}</span>
                        <!-- <span>{{ item.sumGrid - item.cabCount}}</span> -->
                      </div>
                      <div v-else>
                        <span class="last">已用托盘/总托盘：</span>
                        <span>{{
                            (item.sumGrid ? item.sumGrid : 0) +
                            "/" +
                            item.cabCount
                          }}</span>
                      </div>
                    </div>
                  </el-radio>
                  <!--  <span
                  class="chooseText"
                  v-if="item.cabType == 2"
                  @click="onSelectCabinet(item)"
                  >选择</span
                >  -->
                </label>
              </div>
            </div>
          </el-dialog>

          <!--      ***************************************************************    -->
        </div>
        <!--右侧-->
        <div class="right2">
          <div class="line">
            <div class="leftText">
              分类
            </div>
            <!--
                :disabled="type == 2" -->
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入分类"
                  v-model="form.category"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              英文名
              <!-- <span class="requiedText">*</span> -->
              <!-- :disabled="type == 2" -->
            </div>
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入英文名"
                  v-model="form.enName"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              品牌
              <!-- <span class="requiedText">*</span> -->
              <!-- :disabled="type == 2" -->
            </div>
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入品牌"
                  v-model="form.goodsSupplierName"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              包装规格
              <!-- <span class="requiedText">*</span> -->
              <!-- :disabled="type == 2" -->
            </div>
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入包装规格"
                  v-model="form.spec"
              />
            </div>
          </div>
          <div class="line">
            <div class="leftText">
              过期时间
              <!-- <span class="requiedText">*</span> -->
              <!-- :disabled="type == 2" -->
            </div>
            <!--            <div class="rightBox">-->
            <el-date-picker
                formart="yyyy-MM-dd"
                value-formart="yyyy-MM-dd"
                v-model="form.expires"
                type="date"
                placeholder="请输入过期时间">
            </el-date-picker>
            <!--            </div>-->
          </div>
        </div>

      </div>
      <div class="innerBox">
        <!--备注-->
        <div class="left2">
          <div class="line">
            <div class="leftText">
              备注
            </div>
            <!--
                :disabled="type == 2" -->
            <div class="rightBox">
              <input
                  type="text"
                  placeholder="请输入备注"
                  v-model="form.remark"
              />
            </div>
          </div>
        </div>

      </div>
      <!--图片底部-->
      <div class="innerBox">
        <div class="right">
<!--          <div class="imgBox">-->
<!--            <div class="name">-->
<!--              <div class="text1">-->
<!--                结构式-->
<!--                &lt;!&ndash; <span class="requiedText">*</span> &ndash;&gt;-->
<!--              </div>-->
<!--              <div class="text2">(非必填)</div>-->
<!--            </div>-->
<!--            <div-->
<!--                v-show="form.structionImg"-->
<!--                style="width: 84px; height: 84px; position: relative"-->
<!--            >-->
<!--              <i-->
<!--                  @click="removeImg('structionImg')"-->
<!--                  class="el-icon-error"-->
<!--                  style="-->
<!--                  position: absolute;-->
<!--                  right: 0;-->
<!--                  top: 0;-->
<!--                  font-size: 20px;-->
<!--                  z-index: 10;-->
<!--                "-->
<!--              ></i>-->
<!--              <el-image-->
<!--                  style="width: 84px; height: 84px"-->
<!--                  :src="form.structionImg"-->
<!--                  :preview-src-list="[form.structionImg]"-->
<!--                  alt=""-->
<!--              ></el-image>-->
<!--            </div>-->
<!--            <UpImage-->
<!--                @uploadImgs="getStructionImg"-->
<!--                types="structionImg"-->
<!--                v-show="!form.structionImg"-->
<!--            >-->
<!--              <img-->
<!--                  style="width: 84px; height: 84px"-->
<!--                  src="../../assets/images/upload.png"-->
<!--                  alt=""-->
<!--              />-->
<!--            </UpImage>-->
<!--          </div>-->
<!--          <div class="imgBox">-->
<!--            <div class="name">-->
<!--              <div class="text1">产品图片</div>-->
<!--              <div class="text2">(非必填)</div>-->
<!--            </div>-->
<!--            <div-->
<!--                v-show="form.coverImg"-->
<!--                style="width: 84px; height: 84px; position: relative"-->
<!--            >-->
<!--              <i-->
<!--                  @click="removeImg('coverImg')"-->
<!--                  class="el-icon-error"-->
<!--                  style="-->
<!--                  position: absolute;-->
<!--                  right: 0;-->
<!--                  top: 0;-->
<!--                  font-size: 20px;-->
<!--                  z-index: 10;-->
<!--                "-->
<!--              ></i>-->
<!--              <el-image-->
<!--                  style="width: 84px; height: 84px"-->
<!--                  :src="form.coverImg"-->
<!--                  :preview-src-list="[form.coverImg]"-->
<!--                  alt=""-->
<!--              ></el-image>-->
<!--            </div>-->
<!--            <UpImage-->
<!--                @uploadImgs="getCoverImg"-->
<!--                types="coverImg"-->
<!--                v-show="!form.coverImg"-->
<!--            >-->
<!--              <img-->
<!--                  style="width: 84px; height: 84px"-->
<!--                  src="../../assets/images/upload.png"-->
<!--                  alt=""-->
<!--              />-->
<!--            </UpImage>-->
<!--          </div>-->
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <!-- 选择门禁柜位置 -->
          <el-dialog
              title="选择托盘/查看已存试剂"
              :visible.sync="dialogSelect"
              width="900px"
              class="selectLocationBox"
          >
            <div class="btnWrapper" style="margin-bottom: 15px">
              <el-button type="primary" size="small" @click="selectPlace"
              >确定选择托盘</el-button
              >
              <el-button size="small" @click="getCabinetDetail"
              >查看已存试剂</el-button
              >
<!--              <el-button size="small" @click="openEditNum"-->
<!--              >修改存储数量</el-button-->
<!--              >-->
            </div>
            <el-table
                :data="selectLocationList2"
                border
                @cell-click="handleCellClick"
                :cell-style="handleCellStyle"
                style="width: 100%; height: 100%"
                max-height="500"
            >
              <el-table-column type="index" width="70px" :index="indexMethod">
              </el-table-column>

              <el-table-column
                  v-for="(item, index) in dataColumn"
                  :key="index"
                  :label="colIndexArr[index] + '列'"
                  min-width="120px"
              >
                <template slot-scope="scope">
                  <div
                      v-if="scope.row[index].isDel"
                      style="
                      text-decoration: line-through;
                      background-color: #d9d9d9;
                    "
                  >
                    {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                    <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                    {{ scope.row[index].numX }}, {{ scope.row[index].numY }}（余-->
<!--                    <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                        scope.row[index].reagentTotalNum - -->
<!--                        scope.row[index].reagentNum-->
<!--                      }}</span>-->
<!--                    <span v-else>0</span>-->
<!--                    ）-->
                  </div>
                  <span v-else>
                    {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                    {{ scope.row[index].numX }}, {{ scope.row[index].numY }}（余-->
<!--                    <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                        scope.row[index].reagentTotalNum - -->
<!--                        scope.row[index].reagentNum-->
<!--                      }}</span>-->
<!--                    <span v-else>0</span>-->
<!--                    ）-->
                  </span>
                </template>
              </el-table-column>
            </el-table>

            <div style="margin-top: 10px">
              共计{{ lockerCabinet.numX }} 行{{ lockerCabinet.numY }} 列<span
                style="margin-left: 10px"
            >{{ lockerCabinet.numX * lockerCabinet.numY }}个托盘</span
            >
            </div>

            <!--            <el-table :data="selectLocationList" style="width: 100%">-->
            <!--              <el-table-column label="位置" width="180">-->
            <!--                <template slot-scope="scope">-->
            <!--                  <span>{{ scope.row.numX + "," + scope.row.numY }}</span>-->
            <!--                </template>-->
            <!--              </el-table-column>-->
            <!--              <el-table-column prop="reagentNum" label="已存数量" width="180">-->
            <!--              </el-table-column>-->
            <!--              <el-table-column label="操作">-->
            <!--                <template slot-scope="scope">-->
            <!--                  <span class="selectText" @click="onSelectLocation(scope.row)"-->
            <!--                    >选择</span-->
            <!--                  >-->
            <!--                </template>-->
            <!--              </el-table-column>-->
            <!--            </el-table>-->
            <!--            <Pagination-->
            <!--              :dataTotal="locationDataTotal"-->
            <!--              :totalpage="locationTotalpage"-->
            <!--              :pagesize="locationSearchData.pageSize"-->
            <!--              @changePage="locationChangePage"-->
            <!--            ></Pagination>-->
            <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="dialogSelect = false">取 消</el-button>
              <el-button type="primary" @click="dialogSelect = false">确 定</el-button>
            </span> -->
          </el-dialog>

          <!--    查看试剂弹出框-->
          <el-dialog
              title="查看已存试剂"
              :visible.sync="cabinetDetailVisible"
              width="600px"
          >
            <span style="color: black; font-weight: bold"
            >托盘码：{{ placeCode }}</span
            >
            <span style="margin-left: 100px; color: black; font-weight: bold"
            >已存数量：{{ lockerCabinetGrid.reagentNum }}</span
            >
            <!--            <div style="margin-top: 10px;color: black;font-weight: bold">已存试剂列表</div>-->
            <el-table :data="newReagentList" border style="margin-top: 10px">
              <el-table-column label="试剂编号" prop="id">
                <template v-slot="scope">
                  <span v-if="scope.row.code">{{scope.row.code}}</span>
                  <span v-else>{{scope.row.id}}</span>
                </template>
              </el-table-column>
              <el-table-column label="试剂名称" prop="reagentName">
              </el-table-column>
              <el-table-column label="试剂状态" prop="">
                <template slot-scope="scope">
                  {{ handleStatusConvert(scope.row.operation) }}
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="cabinetDetailVisible = false">取 消</el-button>
              <el-button type="primary" @click="cabinetDetailVisible = false"
              >确 定</el-button
              >
            </span>
          </el-dialog>

          <!-- 修改存储数量 dialog-->
          <el-dialog
              title="修改存储数量"
              :visible.sync="editNumDialog"
              class="placeDia"
              width="600px"
          >
            <el-row style="text-align: center; line-height: 40px">
              <el-col :span="4">
                <span>存储数量</span>
              </el-col>
              <el-col :span="8">
                <el-input
                    v-model="editNum"
                    type="number"
                    :disabled="editInputDisable"
                />
              </el-col>
              <el-col :span="8">
                <el-button
                    type="primary"
                    style="padding: 7px 14px"
                    @click="editInputDisable = false"
                >修改</el-button
                >
                <el-button
                    type="primary"
                    style="padding: 7px 14px"
                    @click="saveEditNum"
                >保存</el-button
                >
              </el-col>
            </el-row>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { client } from "../../oss/oss";
export default {
  data() {
    return {
      initEditGrid: null,
      editInputDisable: true,
      editNum: null,
      editNumDialog: false,
      cabNametext: "",
      reagentList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      list: [],
      showTable: false,
      searchCab: "",
      searchCab2: "",
      form: {
        casNo: "",
        reagentWeightUnit: 2, // 表单默认单位
        cabType: null,
        expires:null,
        reagentWeight:null,
        reagentRemainWeight:null,
        // structionImg: require('../../assets/images/upload.png'),
        // coverImg:require('../../assets/images/upload.png')
      },
      currentCommand: "g", //控件默认单位
      dataObj: {
        host: "",
      },
      //默认 1 添加模式 2编辑模式
      type: 1,
      dataTotal: 0,
      totalpage: 0,
      searchData: {
        pageSize: 10,
        pageNum: 1,
      },

      hideUploadEdit1: false,
      hideUploadEdit2: false,

      structionImages: [],
      coverImgs: [],

      //选择门禁柜位置
      //当前门禁柜
      currentLocationId: "",
      dialogSelect: false,
      dialog1Select: false,

      selectLocationList: [],
      locationDataTotal: 0,
      locationTotalpage: 0,
      locationSearchData: {
        pageSize: 10,
        pageNum: 1,
      },
      //选择位置
      selectLocationId: "",
      lockerCabinet: {
        columnList: [],
        rowList: [],
        numX: "",
        numY: "",
      },
      row: "",
      column: "",
      rowIndex: "",
      columnIndex: "",
      popVisible: false,
      cabinetDetailVisible: false,
      placeCode: "",
      lockerCabinetGrid: {},
      newReagentList: [],
      colIndexArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "U",
        "V",
        "W",
        "x",
        "Y",
        "Z",
      ],
      selectLocationList2: [],
      dataColumn: null,
      editFlag: false,
    };
  },
  created() {
    if (this.$route.params.type) {
      this.editFlag = true;
      //编辑模式
      this.type = 2;
      this.operation = this.$route.params.operation;

      //塞数据
      const currentReagent = JSON.parse(
          localStorage.getItem("currentEditReagent")
      );
      console.log("currentReagent = ", currentReagent);
      this.queryCabinetGridById(currentReagent.gridId);
      console.log(this.searchCab);
      const {
        casNo,
        goodsNo,
        reagentName,
        reagentWeight,
        reagentRemainWeight,
        reagentWeightUnit,
        structionImg,
        coverImg,
        goodsSupplierName,
        id,
        pure,
        category,
        enName,
        spec,
        expires,
        remark,
      } = currentReagent;
      this.form.casNo = casNo;
      this.form.reagentName = reagentName;
      this.form.goodsNo = goodsNo;
      this.form.reagentWeight = reagentWeight;
      this.form.reagentRemainWeight = reagentRemainWeight;
      this.form.reagentWeightUnit = reagentWeightUnit;
      // this.currentCommand = reagentWeightUnit == 1 ? "mL" : "g";
      this.currentCommand = this.$store.state.unit[reagentWeightUnit];
      this.form.goodsSupplierName = goodsSupplierName;

      this.form.pure = pure;
      this.form.category = category;
      this.form.enName = enName;
      this.form.spec = spec;
      this.form.expires = expires==undefined?'':expires;
      console.log("xixi",this.form.expires)
      this.form.remark = remark;

      this.form.id = id;
      if (structionImg) {
        console.log(structionImg);
        this.structionImages = [
          {
            name: reagentName + "struction" + Date.now() + ".png",
            url: structionImg,
          },
        ];
        this.$set(this.form, "structionImg", structionImg);
        // this.form.structionImg = structionImg;
      }

      if (coverImg) {
        console.log(coverImg);
        this.coverImgs = [
          {
            name: reagentName + "cover" + Date.now() + ".png",
            url: coverImg,
          },
        ];
        this.$set(this.form, "coverImg", coverImg);
        // this.form.coverImg = coverImg;
      }
    }
  },
  mounted() {
    //this.getCanUseList();
    // this.getOss()
    this.getAllCanUseList();
    if(this.$route.query.page == 'return'){
      let data = localStorage.getItem("tempAddReagent");
      console.log(this)
      this.form=JSON.parse(data)
      this.getCanUseList();
      localStorage.removeItem("tempAddReagent")
    }
  },
  beforeRouteEnter(to, from, next) {
    //to是当前页面,from是从哪里来,next是放行
    console.log(to.query.name);
    if (to.query.name) {
      to.meta.title = to.query.name; //获取从上个页面传过来的name再进行修改
    }
    next(); //切记操作完一定要记得放行,否则无法正常跳转页面
  },

  watch:{
    'form.reagentWeight'(newValue,oldValue){
      // console.log("剩余剂量监听", this.form.reagentRemainWeight)
      if(this.editFlag){
        this.editFlag = false;
      }else{
        this.form.reagentRemainWeight = newValue
      }
    }
  },
  methods: {
    newCabinet(){
      let data = JSON.stringify(this.form);
      localStorage.setItem("tempAddReagent",data);
      this.$router.push({path:'cabinetRun10',query:{'type':'add'}});
    },

    // weightInput(value){
    //   console.log(value)
    //   this.form.reagentRemainWeight = this.form.reagentWeight
    // },
    //    // 表头行
    indexMethod(index) {
      return "第" + (index + 1) + "行";
    },
    // 查询余数
    // 数据处理
    getNewData(data) {
      this.selectLocationList2 = [];
      for (let i = 1; i <= this.lockerCabinet.numX; i++) {
        this.selectLocationList2.push(data[`${i}`]);
      }
      console.log("new Data", this.selectLocationList2);
      this.dataColumn = this.selectLocationList2[0];
    },

    // 获取当前门禁中位置
    async getCurrentLocationInit() {
      const id = this.currentLocationId;
      const { data } = await this.$apiFetch.get(
          "/cabinetGrid/queryCabinetGridList2",
          { id }
      );
      if (!data.code) {
        this.getNewData(data);
      }
    },

    // 根据id查询柜子
    queryCabinetGridById(id) {
      if (id) {
        this.$apiFetch
            .get(`/cabinetGrid/queryCabinetGridById/${id}`)
            .then((res) => {
              this.searchCab =
                  res.data.cabName +
                  "（" +
                  res.data.numX +
                  "," +
                  res.data.numY +
                  "）";
              this.form.cabId = res.data.cabId;
              this.form.gridId = res.data.id;
              this.form;
              console.log(res);
            });
      }
    },

    //打开编辑 数量
    openEditNum() {
      if (
          !(
              this.row != undefined &&
              this.column != undefined &&
              this.row != "" &&
              this.column != ""
          )
      ) {
        this.$message.error("请先选择位置");
        return;
      }

      this.$apiFetch
          .post(`/cabinetGrid/getLockerCabinetGrid/`, {
            cabId: this.lockerCabinet.id,
            numX: this.rowIndex,
            numY: this.columnIndex,
          })
          .then((res) => {
            if(res.data.del){
              this.$message.error("该位置已被禁用，不能修改数量~")
              return ;
            }
            this.editNumDialog = true;
            this.lockerCabinetGrid = res.data;
            this.editNum = res.data.reagentTotalNum;
          });
    },

    // 修改数量 保存按钮
    saveEditNum() {
      this.placeCode =
          this.lockerCabinet.cabName +
          "（" +
          this.rowIndex +
          "," +
          this.columnIndex +
          "）";
      this.$apiFetch
          .post(`/cabinetGrid/getLockerCabinetGrid/`, {
            cabId: this.lockerCabinet.id,
            numX: this.rowIndex,
            numY: this.columnIndex,
          })
          .then((res) => {
            this.lockerCabinetGrid = res.data;
            let ids = [];
            ids.push(res.data.id);
            this.$apiFetch
                .post(`/cabinetGrid/editGridNumByIds/${this.editNum}`, ids)
                .then((res) => {
                  if (res.status == 200) {
                    if(res.data.code){
                      this.$message.error("该位置已被禁用，不能修改数量~")
                      return ;
                    }
                    this.$message.success("修改成功");
                    this.getCurrentLocation();
                    this.getCurrentLocationInit();
                  } else {
                    this.$message.success("修改失败");
                  }
                });
            this.editNumDialog = false;
            this.editNum = "";
            this.editInputDisable = true;
          });
    },

    handleStatusConvert(status) {
      if (status == 8) {
        return (status = "订购中");
      } else if (status == 1) {
        return (status = "待入库");
      } else if (status == 2) {
        return (status = "在库");
      } else if (status == 3) {
        return (status = "已借出");
      } else if (status == 4) {
        return (status = "已取出");
      } else if (status == 5) {
        return (status = "移除中");
      } else if (status == 6) {
        return (status = "移除成功");
      } else if (status == 7) {
        return (status = "转借申请中");
      } else if (status == 88) {
        return (status = "购物车中");
      } else if (status == 9) {
        return (status = "盘点中");
      } else if (status == 10) {
        return (status = "盘点遗失");
      } else {
        return (status = "-");
      }
    },

    selectPlace() {
      if (
          !(
              this.row != undefined &&
              this.column != undefined &&
              this.row != "" &&
              this.column != ""
          )
      ) {
        this.$message.error("请先选择位置");
        return;
      }
      this.$apiFetch
          .post(`/cabinetGrid/getLockerCabinetGrid/`, {
            cabId: this.lockerCabinet.id,
            numX: this.rowIndex,
            numY: this.columnIndex,
          })
          .then((res) => {
            if (res.data.del) {
              this.$message.error("该位置已被禁用，请重新选择");
              return;
            } else {
              this.dialogSelect = false;
              this.form.gridId = res.data.id;
              this.placeCode =
                  this.lockerCabinet.cabName +"（" +this.rowIndex +"," +this.columnIndex +"）";
              this.searchCab =this.lockerCabinet.cabName +"（" + this.rowIndex +"," +this.colIndexArr[this.columnIndex - 1] +"）";
              this.form.cabId = this.currentLocationId;
              this.form.cabType = 2;
              this.form.numX = this.rowIndex;
              this.form.numY = this.colIndexArr[this.columnIndex - 1];
            }
          });
    },
    getCabinetDetail() {
      if (
          !(
              this.row != undefined &&
              this.column != undefined &&
              this.row != "" &&
              this.column != ""
          )
      ) {
        this.$message.error("请先选择位置");
        return;
      }
      this.placeCode =
          this.lockerCabinet.cabName +
          "（" +
          this.rowIndex +
          "," +
          this.columnIndex +
          "）";

      this.$apiFetch
          .post(`/cabinetGrid/getLockerCabinetGrid/`, {
            cabId: this.lockerCabinet.id,
            numX: this.rowIndex,
            numY: this.columnIndex,
          })
          .then((res) => {
            this.lockerCabinetGrid = res.data;
            this.placeCode =this.lockerCabinet.cabName +"(" +this.lockerCabinetGrid.numX +"," + this.lockerCabinetGrid.numY +")";
            this.$apiFetch
                .get(`/cabinetGrid/queryReagentByGrid/${res.data.id}`)
                .then((res) => {
                  if (res.status == 200) {
                    if(res.data.code){
                      this.$message.error(res.data.description);
                      return ;
                    }
                    this.cabinetDetailVisible = true;
                    this.newReagentList = res.data;
                  }
                });
          });
    },
    handleCellStyle(row, rowIndex, column) {
      if (this.row === row.row && this.column === row.column) {
        this.rowIndex = row.rowIndex + 1;
        this.columnIndex = row.columnIndex;
        return "background-color:#00b050;";
      } else {
        return "background-color:#fff;cursor:pointer;";
      }
    },

    handleCellClick(row, column, cell, event) {
      this.row = row; // 取个唯一值用作判定行
      this.column = column;
    },
    // 关闭快速查询cas 的表格，通过顶层父元素事件触发关闭
    closeSelectCollapse(event) {
      let dom = document.getElementById("slectTable");
      if (dom) {
        if (!dom.contains(event.target)) {
          // 防止事件冒泡
          this.showTable = false;
        }
      }
    },
    reagentWeightBlur() {
      let value = this.form.reagentWeight+"";
      let value2 = this.form.reagentRemainWeight+"";
      if(value){
        if (value.slice(value.length - 1, value.length) == ".") {
          this.form.reagentWeight = value.slice(0, value.length - 1);
        }
      }
      if(value2) {
        if (value2.slice(value2.length - 1, value2.length) == ".") {
          this.form.reagentRemainWeight = value2.slice(0, value2.length - 1);
        }
      }
    },
    back() {
      this.$router.back();
    },
    handleRemove(file, type) {
      console.log(file, type);
      let fileList;
      if (type == "structionImg") {
        fileList = this.$refs.upload1.uploadFiles;
        this.form.structionImg = "";
        this.hideUploadEdit1 = false;
      } else {
        fileList = this.$refs.upload2.uploadFiles;
        this.form.coverImg = "";
        this.hideUploadEdit2 = false;
      }

      let index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      fileList.splice(index, 1);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getReagentList() {
      const { pageSize, pageNum } = this.searchData;
      this.$apiFetch
          .get(`/lockerReagent/queryTansuoById`, {
            casNo: this.form.casNo.trim(),
            pageSize,
            pageNum,
          })
          .then((res) => {
            console.log(res);
            this.reagentList = res.data.list;
            this.dataTotal = res.data.total;
            this.totalpage = res.data.pages;
          });
    },
    getCanUseList() {
      this.$apiFetch
          .get(`/lockerCabinet/queryAvailableCabList`, {
            cabName: "",
          })
          .then((res) => {
            console.log(res);
            this.list = res.data;
          });
      this.dialog1Select = true;
      this.searchCab2 = "";
    },
    getCanUseList2() {
      this.$apiFetch
          .get(`/lockerCabinet/queryAvailableCabList`, {
            cabName: this.searchCab2,
          })
          .then((res) => {
            console.log(res);
            this.list = res.data;
          });
    },
    getAllCanUseList() {
      this.$apiFetch
          .get(`/lockerCabinet/queryAvailableCabList`)
          .then((res) => {
            console.log(res);
            this.list = res.data;
          });
    },
    quickSearchClick() {
      if (!this.form.casNo) {
        this.$message.error("请输入CAS号查询");
        return;
      }
      if (!this.showTable) {
        this.getReagentList();
      }
      this.showTable = !this.showTable;
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.getReagentList();
    },
    locationChangePage(data) {
      this.locationSearchData.pageNum = data;
      this.getCurrentLocation();
    },
    handleCommand(command) {
      this.currentCommand = command.text;
      this.form.reagentWeightUnit = command.val;
    },
    imgChange(file, type) {
      console.log(file, type);
      if (type == "structionImg") {
        this.form.structionImg = file.url;
      } else {
        this.form.coverImg = file.url;
      }
    },
    upLoad(file, type) {
      const self = this;
      const isLt2M = file.file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }

      let files = file.file,
          point = files.name.lastIndexOf("."),
          suffix = files.name.substr(point),
          fileName = files.name.substr(0, point),
          date = Date.parse(new Date()),
          fileNames = `${fileName}_${date}${suffix}`;

      if (type == "structionImg") {
        this.hideUploadEdit1 = true;
      } else {
        this.hideUploadEdit2 = true;
      }
      //fileNames上传文件的名称
      //file.file上传文件的内容
      client(this.dataObj)
          .multipartUpload(fileNames, file.file)
          .then((result) => {
            //下面是如果对返回结果再进行处理，根据项目需要
            console.log(result);
            if (type == "structionImg") {
              this.form.structionImg = result.res.requestUrls[0];
            } else {
              this.form.coverImg = result.res.requestUrls[0];
            }
            self.$message({
              message: "上传成功",
              type: "success",
            });
          })
          .catch((err) => {
            console.log(err);
            self.$message.error("上传失败,请重试");
          });
    },
    confirmAdd1() {
      const params = this.form;
      console.log("from", this.form);

      // console.log("刚开始的params：",params)
      const {
        casNo,
        reagentName,
        // goodsNo,
        reagentWeight,
        reagentRemainWeight,
        cabId,
        // structionImg,
        cabType,
      } = params;
      if (!casNo) { //  // !goodsNo ||// ||!cabId// || !structionImg
        this.$message.error("请填写完整后提交");
        return;
      }
      if(reagentWeight && !reagentRemainWeight){
        this.$message.error("剩余剂量不能为空");
        return;
      }
      if(reagentRemainWeight && !reagentWeight){
        this.$message.error("总剂量不能为空");
        return;
      }
      if(reagentRemainWeight && reagentWeight){
        if(new Number(reagentRemainWeight) > new Number(reagentWeight)){
          this.$message.error("剩余剂量不能大于总剂量");
          return;
        }
      }
      if(null == reagentWeight || ''==reagentWeight){
        params.reagentWeight = 0;
      }
      if(null == reagentRemainWeight || ''==reagentRemainWeight){
        params.reagentRemainWeight = 0;
      }
      // 选择了柜机 但不选门禁柜 柜机也为空
      if(params.cabType == 2 && (params.cabId!=undefined || params.cabId!=null) && (params.gridId == undefined || params.gridId == null)){
        params.cabId = null;
      }

      console.log("cabType = ", cabType);
      console.log("params.gridId = ", params.gridId);
      console.log("params.numX = ", params.numX);
      console.log("params.numY = ", params.numY);
      // if (cabType === 2 && (!params.gridId || !params.numX || !params.numY)) { // by 11.2 单条新增无柜机可保存
      //   this.$message.error("请选择位置后提交");
      //   return;
      // }
      var reagentWeightUnit = params.reagentWeightUnit;
      // 以后改单位记得，
      console.log(params);
      this.$apiFetch
          .post(`/lockerReagentFree/insertReagent`, params)
          .then((res) => {
            console.log(res);
            //this.reagentList = res.data.list
            if (!res.data.code) {
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              this.$router.push("/ReagentRunFree");
            }
          });
    },
    fillIn(data) {
      console.log(data);
      this.form.casNo = data.casNo;
      this.form.reagentName = data.reagentName;
      // this.form.goodsNo = data.goodsNo;// 商品编号
      this.form.goodsSupplierName = data.reason;
      this.form.reagentWeight = parseFloat(data.specNames); //data.specNames.replace("gR",'').replace("g",'').replace("ml",'');
      this.form.reagentWeightUnit = data.specNames
          .replace("gR", "")
          .replace("g", "")
          .replace("ml", "");
      // debugger;

      if (data.specNames.indexOf("ml") != -1) {
        this.form.currentCommand = "ml";
      }
      if (data.specNames.indexOf("gR") != -1) {
        this.form.currentCommand = "g";
      }
      if (data.specNames.indexOf("g") != -1) {
        this.form.currentCommand = "g";
      }
      this.structionImages = [
        {
          name: data.reagentName + "struction" + Date.now() + ".png",
          url: data.structionImg,
        },
      ];
      if(data.structionImg){
        this.form.structionImg = data.structionImg;
      }
      this.hideUploadEdit1 = true;

      if (data.coverImg) {
        this.coverImgs = [
          {
            name: data.reagentName + "cover" + Date.now() + ".png",
            url: data.coverImg,
          },
        ];
        this.form.coverImg = data.coverImg;
        this.hideUploadEdit2 = true;
      }
      this.showTable = false;
      // this.currentCommand = "g"; // 快速查询 - 填入后 - 将单位默认为g
      this.currentCommand = this.unitAdapter(data.specNames); // 获取单位 ml g kg l mg
      this.form.reagentWeightUnit = this.reverseUnit(this.currentCommand); // 并设置默认单位 2
      console.log("xixi =", this.currentCommand, data.specNames);
    },

    // 单位适配 参数为：重量+单位
    unitAdapter(specNames) {
      if (
          specNames.indexOf("mL") != -1 ||
          specNames.indexOf("ml") != -1 ||
          specNames.indexOf("Ml") != -1 ||
          specNames.indexOf("ML") != -1
      ) {
        return "mL";
      } else if (specNames.indexOf("L") != -1 || specNames.indexOf("l") != -1) {
        return "L";
      } else if (
          specNames.indexOf("mg") != -1 ||
          specNames.indexOf("mG") != -1 ||
          specNames.indexOf("Mg") != -1 ||
          specNames.indexOf("MG") != -1
      ) {
        return "mg";
      } else if (
          specNames.indexOf("KG") != -1 ||
          specNames.indexOf("kg") != -1 ||
          specNames.indexOf("Kg") != -1 ||
          specNames.indexOf("kG") != -1
      ) {
        return "kg";
      } else if (
          specNames.indexOf("KU") != -1 ||
          specNames.indexOf("ku") != -1 ||
          specNames.indexOf("Ku") != -1 ||
          specNames.indexOf("kU") != -1
      ) {
        return "KU";
      } else if (
          specNames.indexOf("U") != -1 ||
          specNames.indexOf("u") != -1
      ) {
        return "U";
      } else {
        return "g"; // 默认为g
      }
    },

    // 单位
    unit(reagentWeightUnit) {
      //单位适配
      return reagentWeightUnit == 1
          ? "mL"
          : reagentWeightUnit == 7
              ? "U"
          : reagentWeightUnit == 6
              ? "KU"
          : reagentWeightUnit == 5
              ? "kg"
              : reagentWeightUnit == 3
                  ? "mg"
                  : reagentWeightUnit == 4
                      ? "L"
                      : "g";
    },
    // 单位 根据单位获取 单位数字
    reverseUnit(specNames) {
      if (
          specNames.indexOf("mL") != -1 ||
          specNames.indexOf("ml") != -1 ||
          specNames.indexOf("Ml") != -1 ||
          specNames.indexOf("ML") != -1
      ) {
        return 1;
      } else if (specNames.indexOf("L") != -1 || specNames.indexOf("l") != -1) {
        return 4;
      } else if (
          specNames.indexOf("mg") != -1 ||
          specNames.indexOf("mG") != -1 ||
          specNames.indexOf("Mg") != -1 ||
          specNames.indexOf("MG") != -1
      ) {
        return 3;
      } else if (
          specNames.indexOf("KG") != -1 ||
          specNames.indexOf("kg") != -1 ||
          specNames.indexOf("Kg") != -1 ||
          specNames.indexOf("kG") != -1
      ) {
        return 5;
      } else if (
          specNames.indexOf("KU") != -1 ||
          specNames.indexOf("ku") != -1 ||
          specNames.indexOf("Ku") != -1 ||
          specNames.indexOf("kU") != -1
      ) {
        return 6;
      } else if (
          specNames.indexOf("U") != -1 ||
          specNames.indexOf("u") != -1
      ) {
        return 7;
      } else {
        return 2; // 默认为g
      }
    },

    async getOss() {
      let url = "/aliyun/oss-token";
      const { data } = await this.$apiFetch.get(url);
      console.log(data);
      this.dataObj = data;
    },
    confirmEdit1() {
      const params = this.form;
      const { casNo, reagentName, goodsNo, reagentWeight, cabId, cabType ,reagentRemainWeight} =
          params;
      if (!casNo || !reagentName) {
        this.$message.error("请填写完整后提交");
        return;
      }
      if(reagentWeight && !reagentRemainWeight){
        this.$message.error("剩余剂量不能为空");
        return;
      }
      if(reagentRemainWeight && !reagentWeight){
        this.$message.error("总剂量不能为空");
        return;
      }
      if(reagentRemainWeight && reagentWeight){
        if(new Number(reagentRemainWeight) > new Number(reagentWeight)){
          this.$message.error("剩余剂量不能大于总剂量");
          return;
        }
      }
      if(null == reagentWeight || ''==reagentWeight){
        params.reagentWeight = 0;
      }
      if(null == reagentRemainWeight || ''==reagentRemainWeight){
        params.reagentRemainWeight = 0;
      }
      if(params.cabType == 2 && (params.cabId!=undefined || params.cabId!=null) && (params.gridId == undefined || params.gridId == null)){
        console.log("xixi")
        params.cabId = null;
      }
      if (this.operation == "-" || this.operation == "待编辑" || this.operation=="盘点遗失") {
        this.$apiFetch
            .post(`/lockerReagentFree/updateForLockerReagent`, params)
            .then((res) => {
              console.log(res);
              //this.reagentList = res.data.list
              if (!res.data.code) {
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                this.$router.push("/ReagentRunFree");
              }
            });
      } else {
        this.$apiFetch
            .post(`/lockerReagent/updateForLockerReagentByReagent`, params)
            .then((res) => {
              console.log(res);
              //this.reagentList = res.data.list
              if (!res.data.code) {
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                this.$router.push("/ReagentRunFree");
              }
            });
      }
    },
    handleEditChange(file, fileList) {
      console.log(file);
      let vm = this;
      vm.hideUploadEdit1 = fileList.length >= 1;
    },
    handleEditChange2(file, fileList) {
      console.log(file);
      let vm = this;
      vm.hideUploadEdit2 = fileList.length >= 1;
    },
    getStructionImg(data) {
      this.$set(this.form, "structionImg", data[0]);
    },
    getCoverImg(data) {
      this.$set(this.form, "coverImg", data[0]);
    },
    //选择柜机 查看位置列表
    onSelectCabinet(data) {
      debugger;
      this.currentLocationId = data.id;
      this.cabNametext = data.cabName;
      this.dialogSelect = true;
      this.getCurrentLocation();
    },
    //获取当前门禁中位置
    async getCurrentLocation() {
      const { currentLocationId } = this;
      const { data } = await this.$apiFetch.get("/lockerCabinet/getCabinet", {
        id: currentLocationId,
      });
      this.lockerCabinet = data;
    },
    onSelectLocation(data) {
      debugger;
      this.form.cabId = this.currentLocationId;
      this.form.gridId = data.id;
      this.form.cabType = 2;
      this.form.numX = data.numX;
      this.form.numY = data.numY;
      this.$message.success("选择成功!");
      this.searchCab =
          this.cabNametext + " " + this.form.numX + "," + this.form.numY;
      this.dialogSelect = false;
      this.dialog1Select = false;
    },
    removeImg(type) {
      if (type == "structionImg") {
        // this.$set(this.form,'structionImg','')
        this.form.structionImg = "";
        this.structionImages = [];
      } else {
        this.form.coverImg = "";
        // this.$set(this.form,'coverImg','')
        this.coverImgs = [];
      }
    },
    onRadioClick(item) {
      if (item.cabType == 2) {
        this.currentLocationId = item.id;
        this.cabNametext = item.cabName;
        this.dialogSelect = true;
        this.dialog1Select = false;
        this.getCurrentLocation();
        this.getCurrentLocationInit(); // by xhb
      } else if (item.cabType == 1) {
        // 智能柜
        this.dialog1Select = false;
        console.log("haha", this.form);
        this.cabNametext = item.cabName;
        this.searchCab = item.cabName;
      }
    },
    onRadioChange(item) {
      console.log(item);
      this.form.cabType = item.cabType;
    },
  },
};
</script>

<style lang="less" scoped>
.topLine {
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  border-bottom: 1px solid #eef2f8;
  min-width: 1160px;
  button {
    width: 110px;
    height: 36px;
    line-height: 1;
    text-align: center;
    color: #fff;
    font-size: 13px;
    border-radius: 4px;
    background: #478aff;

    &:first-child {
      color: #666666;
      background-color: #fff;
      border: 1px solid #999999;
      margin-right: 8px;
    }
  }
}

/deep/.innerBox {
  display: flex;
  padding-left: 20px;
  font-size: 14px;
  min-width: 1160px;
  .left {
    width: 38%;
    .line {
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .leftText {
        width: 94px;
        height: 20px;
        color: #666666;
        line-height: 20px;
      }

      .rightBox {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        position: relative;

        &.xu {
          border-bottom: 1px dashed #cccccc;
        }

        input {
          flex: 1;
          height: 20px;
          line-height: 20px;

          &::placeholder {
            color: #cccccc;
          }
        }

        .searchText {
          color: #478aff;
          cursor: pointer;
        }
      }
      .el-dropdown {
        width: 38px;
        height: 50px;
        margin-left: 16px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
      }
      .el-dropdown {
        color: #333;
      }

      .infoTable {
        width: 100%;
        position: absolute;
        left: 0px;
        top: 60px;
        z-index: 999;

        background-color: #fff;
        border-radius: 4px;

        .el-table {
          border: 1px solid #e8e8e8;
        }
      }
    }

    .list {
      margin-left: 94px;
      display: flex;
      flex-direction: column;
      font-size: 14px;

      .el-radio {
        margin: 0;
      }

      .el-radio.is-bordered {
        padding: 0 12px;
        height: 48px;
        display: flex;
        align-items: center;

        .el-radio__label {
          flex: 1;
          display: flex;
          justify-content: space-between;

          .leftInner {
            flex: 1;
            display: flex;
            .name {
              flex: 1;
              color: #333333;
              // height: 20px;
              line-height: 20px;
              width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .type1,
            .type2 {
              height: 18px;
              line-height: 18px;
              font-size: 12px;
              padding: 1px 6px;
              margin-left: 8px;
              border-radius: 4px;
              margin-right: 20px;
            }

            .type1 {
              color: #478aff;
              background: #eaf1fc;
            }

            .type2 {
              color: #fa8c16;
              background: #faf1e8;
            }
          }

          .rightInner {
            height: 18px;
            line-height: 18px;
            font-size: 13px;
            color: #333;
            width: 150px;
            .last {
              color: #666;
            }
          }
        }
      }

      .listItem {
        position: relative;
        margin: 0 0 8px 0;

        .chooseText {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -45px;
          height: 20px;
          font-size: 14px;
          color: #478aff;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }

    .tableImg {
      width: 50px;
      height: 50px;
    }
  }
  .left2 {
    width: calc(76% + 100px);
    .line {
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .leftText {
        width: 94px;
        height: 20px;
        color: #666666;
        line-height: 20px;
      }

      .rightBox {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        position: relative;

        &.xu {
          border-bottom: 1px dashed #cccccc;
        }

        input {
          flex: 1;
          height: 20px;
          line-height: 20px;

          &::placeholder {
            color: #cccccc;
          }
        }

        .searchText {
          color: #478aff;
          cursor: pointer;
        }
      }
      .el-dropdown {
        width: 38px;
        height: 50px;
        margin-left: 16px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
      }
      .el-dropdown {
        color: #333;
      }

      .infoTable {
        width: 100%;
        position: absolute;
        left: 0px;
        top: 60px;
        z-index: 999;

        background-color: #fff;
        border-radius: 4px;

        .el-table {
          border: 1px solid #e8e8e8;
        }
      }
    }

    .list {
      margin-left: 94px;
      display: flex;
      flex-direction: column;
      font-size: 14px;

      .el-radio {
        margin: 0;
      }

      .el-radio.is-bordered {
        padding: 0 12px;
        height: 48px;
        display: flex;
        align-items: center;

        .el-radio__label {
          flex: 1;
          display: flex;
          justify-content: space-between;

          .leftInner {
            flex: 1;
            display: flex;
            .name {
              flex: 1;
              color: #333333;
              // height: 20px;
              line-height: 20px;
              width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .type1,
            .type2 {
              height: 18px;
              line-height: 18px;
              font-size: 12px;
              padding: 1px 6px;
              margin-left: 8px;
              border-radius: 4px;
              margin-right: 20px;
            }

            .type1 {
              color: #478aff;
              background: #eaf1fc;
            }

            .type2 {
              color: #fa8c16;
              background: #faf1e8;
            }
          }

          .rightInner {
            height: 18px;
            line-height: 18px;
            font-size: 13px;
            color: #333;
            width: 150px;
            .last {
              color: #666;
            }
          }
        }
      }

      .listItem {
        position: relative;
        margin: 0 0 8px 0;

        .chooseText {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -45px;
          height: 20px;
          font-size: 14px;
          color: #478aff;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }

    .tableImg {
      width: 50px;
      height: 50px;
    }
  }
  .right2 {
    width: 38%;
    margin-left: 100px;
    .line {
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .leftText {
        width: 94px;
        height: 20px;
        color: #666666;
        line-height: 20px;
      }

      .rightBox {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        position: relative;

        &.xu {
          border-bottom: 1px dashed #cccccc;
        }

        input {
          flex: 1;
          height: 20px;
          line-height: 20px;

          &::placeholder {
            color: #cccccc;
          }
        }

        .searchText {
          color: #478aff;
          cursor: pointer;
        }
      }
      .el-dropdown {
        width: 38px;
        height: 50px;
        margin-left: 16px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
      }
      .el-dropdown {
        color: #333;
      }

      .infoTable {
        width: 100%;
        position: absolute;
        left: 0px;
        top: 60px;
        z-index: 999;

        background-color: #fff;
        border-radius: 4px;

        .el-table {
          border: 1px solid #e8e8e8;
        }
      }
    }

    .list {
      margin-left: 94px;
      display: flex;
      flex-direction: column;
      font-size: 14px;

      .el-radio {
        margin: 0;
      }

      .el-radio.is-bordered {
        padding: 0 12px;
        height: 48px;
        display: flex;
        align-items: center;

        .el-radio__label {
          flex: 1;
          display: flex;
          justify-content: space-between;

          .leftInner {
            flex: 1;
            display: flex;
            .name {
              flex: 1;
              color: #333333;
              // height: 20px;
              line-height: 20px;
              width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .type1,
            .type2 {
              height: 18px;
              line-height: 18px;
              font-size: 12px;
              padding: 1px 6px;
              margin-left: 8px;
              border-radius: 4px;
              margin-right: 20px;
            }

            .type1 {
              color: #478aff;
              background: #eaf1fc;
            }

            .type2 {
              color: #fa8c16;
              background: #faf1e8;
            }
          }

          .rightInner {
            height: 18px;
            line-height: 18px;
            font-size: 13px;
            color: #333;
            width: 150px;
            .last {
              color: #666;
            }
          }
        }
      }

      .listItem {
        position: relative;
        margin: 0 0 8px 0;

        .chooseText {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -45px;
          height: 20px;
          font-size: 14px;
          color: #478aff;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }

    .tableImg {
      width: 50px;
      height: 50px;
    }
  }
  .right {
    width: 50%;
    display: flex;

    .imgBox {
      display: flex;
      margin-top: 20px;
      margin-left: 150px;
      .name {
        margin-right: 52px;
        .text1 {
          // height: 20px;
          color: #666666;
          line-height: 20px;
        }
        .text2 {
          font-size: 12px;
          color: #cccccc;
          height: 17px;
          line-height: 17px;
        }
      }

      .el-upload--picture-card {
        width: 84px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .el-upload-list__item {
        width: 84px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .el-upload-list__item-actions {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }
  }

  .hide .el-upload--picture-card {
    display: none !important;
  }

  .selectLocationBox {
    .btnWrapper {
      text-align: right;
      .el-button--default {
        border: 1px solid #dcdfe6 !important;
        &:hover {
          color: #409eff !important;
          border-color: #c6e2ff !important;
          background-color: #ecf5ff;
        }
      }
    }
    .el-table {
      border: 1px solid #e8e8e8;

      .el-table thead {
        background-color: #f8fafc;
        color: rgba(0, 0, 0, 0.85);
      }

      .selectText {
        height: 21px;
        font-size: 14px;
        color: #478aff;
        line-height: 21px;
        cursor: pointer;
      }
    }
  }
}

.requiedText {
  color: red;
  font-size: 20px;
  font-weight: 700;
}
.requiedText2 {
  color: orange;
  font-size: larger;
  font-weight: 700;
}


/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  width: 10px;
  height: 10px;
  background-color: #478aff;
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: unset;
  border-color: #409eff;
}
</style>